"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInvoiceReconciliationDto = instanceOfInvoiceReconciliationDto;
exports.InvoiceReconciliationDtoFromJSON = InvoiceReconciliationDtoFromJSON;
exports.InvoiceReconciliationDtoFromJSONTyped = InvoiceReconciliationDtoFromJSONTyped;
exports.InvoiceReconciliationDtoToJSON = InvoiceReconciliationDtoToJSON;
exports.InvoiceReconciliationDtoToJSONTyped = InvoiceReconciliationDtoToJSONTyped;
/**
 * Check if a given object implements the InvoiceReconciliationDto interface.
 */
function instanceOfInvoiceReconciliationDto(value) {
    if (!('facilityName' in value) || value['facilityName'] === undefined)
        return false;
    if (!('stripeInvoiceId' in value) || value['stripeInvoiceId'] === undefined)
        return false;
    if (!('stripeDashboardUrl' in value) || value['stripeDashboardUrl'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('ourShiftCount' in value) || value['ourShiftCount'] === undefined)
        return false;
    if (!('ourTotalCents' in value) || value['ourTotalCents'] === undefined)
        return false;
    if (!('stripeShiftCount' in value) || value['stripeShiftCount'] === undefined)
        return false;
    if (!('stripeTotalCents' in value) || value['stripeTotalCents'] === undefined)
        return false;
    return true;
}
function InvoiceReconciliationDtoFromJSON(json) {
    return InvoiceReconciliationDtoFromJSONTyped(json, false);
}
function InvoiceReconciliationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'facilityName': json['facilityName'],
        'stripeInvoiceId': json['stripeInvoiceId'],
        'stripeDashboardUrl': json['stripeDashboardUrl'],
        'status': json['status'],
        'ourShiftCount': json['ourShiftCount'],
        'ourTotalCents': json['ourTotalCents'],
        'stripeShiftCount': json['stripeShiftCount'],
        'stripeTotalCents': json['stripeTotalCents'],
    };
}
function InvoiceReconciliationDtoToJSON(json) {
    return InvoiceReconciliationDtoToJSONTyped(json, false);
}
function InvoiceReconciliationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'facilityName': value['facilityName'],
        'stripeInvoiceId': value['stripeInvoiceId'],
        'stripeDashboardUrl': value['stripeDashboardUrl'],
        'status': value['status'],
        'ourShiftCount': value['ourShiftCount'],
        'ourTotalCents': value['ourTotalCents'],
        'stripeShiftCount': value['stripeShiftCount'],
        'stripeTotalCents': value['stripeTotalCents'],
    };
}
//# sourceMappingURL=InvoiceReconciliationDto.js.map